import { Box, Typography, Button, Alert } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { triggerDeepLink } from '@core/utils/deep-link';

interface MissingParamsErrorProps {
  errors: string[];
}

export function MissingParamsError({ errors }: MissingParamsErrorProps) {
  const handleClose = () => {
    triggerDeepLink({ action: 'closed' });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        p: 3,
        bgcolor: 'background.default',
      }}
    >
      <WarningIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />

      <Typography variant="h5" gutterBottom>
        Thiếu thông tin bắt buộc
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
        Không thể khởi động ứng dụng do thiếu các thông tin sau:
      </Typography>

      <Box sx={{ width: '100%', maxWidth: 400, mb: 3 }}>
        {errors.map((error, index) => (
          <Alert key={index} severity="error" sx={{ mb: 1 }}>
            {error}
          </Alert>
        ))}
      </Box>

      <Button variant="contained" onClick={handleClose} sx={{ minWidth: 120 }}>
        Đóng
      </Button>
    </Box>
  );
}
